<template>
  <div class="upload-file">
    <el-upload
      class="upload-demo"
      :show-file-list="false"
      :action="apiUrl + '/ticCenter/business/api.v0.platform/fileUpload/uploadOss'"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      :on-exceed="handleExceed"
      :disabled="uploadDisabled || fileList.length >= limit"
      :accept="accept"
    >
      <slot name="btn" :loading="uploadDisabled">
        <div class="upload-btn" v-loading="uploadDisabled">+</div>
      </slot>
    </el-upload>
  </div>
</template>

<script>

export default {
  name: 'TicUpload',
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    apiUrl: {
      type: String,
      default: ''
    },
    format: { // 文件后缀
      type: Array,
      default() {
        return []
      }
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: [],
      uploadDisabled: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.fileList = val
        } else {
          this.fileList = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (this.fileList.length > this.limit) {
        this.$message.warning(`最多上传${this.limit}个文件`);
        return false
      }
      // 可接受的文件后缀名
      const prefix = file.name.substr(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (this.format.length && !this.format.includes(prefix.toLocaleLowerCase())) {
        this.$message.error(`只能上传${this.format.join(',')}格式的文件！`);
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 20MB!');
        return false
      }
      this.uploadDisabled = true
      return true;
    },
    // 上传附件成功
    onSuccess(res, file, fileList) {
      this.uploadDisabled = false
      if (res.resultCode === "0") {
        this.fileList.push({
          name: file.name,
          src: res.data.fileName
        })
        this.$emit('input', this.fileList)
      } else {
        this.$message.error(res.resultMsg)
      }
    },
    handleExceed(files, fileList) {
    },
    onError(res, file, fileList) {
      this.uploadDisabled = false
      this.$message.error('网络异常')
    }
  }
}
</script>

<style scoped lang="scss">
.upload-btn {
  display: inline-block;
  width: 60px;
  height: 60px;
  background: #FFFFFF;
  border: 1px dashed #D2D2D2;
  font-size: 36px;
  color: #BDBDBD;
  line-height: 58px;
  text-align: center;
}
</style>
